// Quản lý phiên đăng nhập RIÊNG của HappySchool — KHÔNG còn qua Firebase Auth
// (trước đây: signInWithCustomToken + auth.currentUser.getIdToken()). Token
// do chính happyschool-api tự ký (JWT), lưu trong localStorage của trình
// duyệt, gửi kèm mỗi lần gọi API qua header Authorization: Bearer <token>.
const STORAGE_KEY = "hs_session_token";
const NAME_KEY = "hs_session_name";

export function setHsToken(token) {
  try { localStorage.setItem(STORAGE_KEY, token); } catch (_) {}
}
export function getHsToken() {
  try { return localStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
}
export function clearHsToken() {
  try { localStorage.removeItem(STORAGE_KEY); localStorage.removeItem(NAME_KEY); } catch (_) {}
}

// Server trả 401 (token không hợp lệ / hết hạn / bị đổi khoá ký / bị buộc đổi
// mật khẩu) -> xoá phiên cũ rồi chuyển THẲNG sang form đăng nhập, kèm 1 dòng
// thông báo (Login.js đọc từ sessionStorage). Trước đây các màn hình chỉ hiện
// nguyên văn "Token không hợp lệ hoặc đã hết hạn" (hoặc rơi sang màn "Tham gia
// trường học") trong khi vẫn tưởng là đang đăng nhập. Chỉ chạy 1 lần dù nhiều
// request cùng lúc cùng trả 401.
let sessionExpiredHandled = false;
export function handleSessionExpired(message) {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;
  clearHsToken();
  try { sessionStorage.setItem("hs_login_notice", message || "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại."); } catch (_) {}
  window.location.assign("/login");
}

// Tên hiển thị — trước đây lấy từ Firebase user.displayName, giờ lưu riêng
// (trả về từ /api/auth/phone-login|phone-register) vì không còn Firebase user.
export function setHsName(name) {
  try { localStorage.setItem(NAME_KEY, name || ""); } catch (_) {}
}
export function getHsName() {
  try { return localStorage.getItem(NAME_KEY) || ""; } catch (_) { return ""; }
}

// Các đường dẫn đã chuyển sang hệ đăng nhập riêng (token JWT) thay vì Firebase
// Auth — dùng ở các cổng đăng nhập chung của cả app (App.js, LayoutMain.js)
// để CHỈ bỏ qua kiểm tra Firebase cho đúng các trang này, không đụng các
// tính năng khác (book, developer portal...) vẫn còn dùng Firebase Auth.
export function isHsManagedPath(pathname) {
  return /^\/(quiz3|happyschool)(\/|$)/.test(pathname || "");
}

// Đọc uid từ token (chỉ để HIỂN THỊ trạng thái đăng nhập trên UI — không dùng
// để cấp quyền, việc xác minh thật luôn nằm ở backend). Token hết hạn/hỏng ->
// trả về null, coi như chưa đăng nhập.
export function getHsUid() {
  const token = getHsToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (payload.exp && Date.now() >= payload.exp * 1000) { clearHsToken(); return null; }
    return payload.uid || null;
  } catch (_) {
    clearHsToken();
    return null;
  }
}
